import {
  useConfig as useCreatConfig,
  withConfig as createWithConfig,
} from '@global-website/library';
import React from 'react';
import { ConfigContext } from './Context';

export const withConfig = <P extends Object = {}>(
  Component: React.ComponentType<P>,
) => createWithConfig<P>(ConfigContext)(Component);

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useConfig = () => useCreatConfig(ConfigContext);
